@if (isBackVisible()) {
  <div
    class="text-simple-train-answer audio-record-train-answer text-center"
    [class.position-absolute]="!hasFrontMedia() && !isVideoFrontResolved()"
    [class.text-simple-train-answer--absolute]="
      !hasFrontMedia() && !isVideoFrontResolved()
    "
    [class.text-simple-train-answer--flow]="
      hasFrontMedia() && !isVideoFrontResolved()
    "
    [class.text-simple-train-answer--video-bottom]="isVideoFrontResolved()"
  >
    <strong>{{ card().backText || t()["train.noAnswerText"] }}</strong>
    @if (card().explanation) {
      <p>{{ card().explanation }}</p>
    }
  </div>
}
